import { Tag } from '@/components/Tag'

interface LeaseTermOptionProps {
	term: string
	baseRent: string
	bestValue?: boolean
	selected?: boolean
	onClick?: () => void
}

export function LeaseTermOption ({
	term,
	baseRent,
	bestValue = false,
	selected = false,
	onClick
}: LeaseTermOptionProps) {
	return (
		<button
			type='button'
			onClick={onClick}
			className={`
        spaces-lease-option spaces:flex spaces:items-center spaces:gap-12 spaces:w-full spaces:p-10 spaces:rounded-12 spaces:transition-colors spaces:cursor-pointer
        ${
									selected
										? 'spaces-selected spaces:border-2 spaces:border-brand-base spaces:bg-canvas-base'
										: 'spaces:border-2 spaces:border-transparent spaces:bg-canvas-base spaces:hover:bg-canvas-4'
								}
      `}
		>
			<span className='spaces:flex-1 spaces:text-left spaces:text-16/24 spaces:font-default spaces:text-content-2 spaces:truncate'>
				{term}
			</span>
			{bestValue && (
				<Tag label='Best Value' color='success' appearance='subtle' size='sm' />
			)}
			<span className='spaces:shrink-0 spaces:text-right spaces:whitespace-nowrap'>
				<span className='spaces:text-16/24 spaces:font-strong spaces:text-content-1'>{baseRent}</span>
				<span className='spaces:text-14/16 spaces:font-default spaces:text-content-3'> Base Rent</span>
			</span>
		</button>
	)
}
